const CONSENT_KEY = 'historioCookieConsent';

export const COOKIE_CONSENT_ACCEPTED = 'accepted';
export const COOKIE_CONSENT_REJECTED = 'rejected';

export const getCookieConsent = () => {
  try {
    const value = localStorage.getItem(CONSENT_KEY);
    if (value === COOKIE_CONSENT_ACCEPTED || value === COOKIE_CONSENT_REJECTED) {
      return value;
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const setCookieConsent = (value) => {
  if (value !== COOKIE_CONSENT_ACCEPTED && value !== COOKIE_CONSENT_REJECTED) {
    return;
  }
  try {
    localStorage.setItem(CONSENT_KEY, value);
  } catch (error) {
    // Ignore storage errors in private browsing contexts.
  }
};

export const loadAnalyticsScripts = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  if (window.__historioAnalyticsLoaded) {
    return;
  }

  const GA_ID = process.env.REACT_APP_GA_ID || 'G-SPZBW393WL';
  const GTM_ID = process.env.REACT_APP_GTM_ID || 'GTM-MWSNKDVG';

  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', GA_ID);

  if (!document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${GA_ID}"]`)) {
    const gtagScript = document.createElement('script');
    gtagScript.async = true;
    gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(gtagScript);
  }

  if (!document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${GTM_ID}"]`)) {
    const gtmScript = document.createElement('script');
    gtmScript.async = true;
    gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;
    document.head.appendChild(gtmScript);
  }

  window.__historioAnalyticsLoaded = true;
};

